import { Pipe, PipeTransform, inject } from '@angular/core';
import { HelpService } from './help.service';

@Pipe({
  name: 'helpLink',
  standalone: true
})
export class HelpLinkPipe implements PipeTransform {
  private service = inject(HelpService);

  /**
   * Pipe for convert link to correct help link
   * @param {String} pageAddress - for example '/m0001'
   * @return {String}
   */
  transform(pageAddress: string): string {
    return this.service.getHelpLink(pageAddress);
  }
}
